import React, { useMemo } from 'react';
import RecordPreview, { type RecordItem } from '#/common/components/RecordPreview';
import RecordPreviewSection from '#/common/components/RecordPreview/RecordPreviewSection';
import type { Location } from '#/graphql/types';
import styled from 'styled-components';

const EMPTY_VALUE = '-';
const GRID_FIELD = { xs: 12, sm: 6, md: 3, lg: 3 };

interface MatchedLocationRecord {
  id: string;
  name: string;
  address: string | null;
  level: string | null;
  parentName: string | null;
}

const fields: RecordItem<MatchedLocationRecord>[] = [
  {
    items: [
      {
        dataField: 'name',
        label: 'Name',
        dataType: 'link',
        url: '/assets/locations/:id',
        valueExpr: 'id',
        gridOptions: GRID_FIELD,
      },
      {
        dataField: 'address',
        label: 'Address',
        dataType: 'string',
        gridOptions: GRID_FIELD,
      },
      {
        dataField: 'level',
        label: 'Level',
        dataType: 'string',
        gridOptions: GRID_FIELD,
      },
      {
        dataField: 'parentName',
        label: 'Parent Location',
        dataType: 'string',
        gridOptions: GRID_FIELD,
      },
    ],
  },
];

const PreviewWrapper = styled.div`
  .MuiGrid-item {
    margin-bottom: 0;
    .record-preview-text {
      font-size: 14px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }
    a {
      font-size: 14px !important;
    }
    .record-preview-label {
      font-size: 12px !important;
    }
  }
  .MuiGrid-container {
    column-gap: 24px;
    flex-flow: row;
  }
`;

export interface MatchedLocationPreviewProps {
  location: Location;
}

const MatchedLocationPreview: React.FC<MatchedLocationPreviewProps> = ({ location }) => {
  const record = useMemo<MatchedLocationRecord>(
    () => ({
      id: location.id,
      name: location.name,
      address: location.address ?? location.buildingAddress ?? null,
      level: location.level ?? null,
      parentName: location.parent?.name ?? null,
    }),
    [location],
  );

  return (
    <PreviewWrapper>
      <div>Currently Matched TC Location</div>
      <RecordPreviewSection>
        <RecordPreview record={record} fields={fields} emptyValue={EMPTY_VALUE} />
      </RecordPreviewSection>
    </PreviewWrapper>
  );
};

export default React.memo(MatchedLocationPreview);
